module.exports = __webpack_public_path__ + "img/montserrat-speciaux.b848aea5.jpg";